import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
export var DrawerCloseButton = function DrawerCloseButton(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'Close drawer panel' : _a$ariaLabel,
      props = __rest(_a, ["className", "onClose", 'aria-label']);

  return React.createElement("div", Object.assign({
    className: css(styles.drawerClose, className)
  }, props), React.createElement(Button, {
    variant: "plain",
    onClick: onClose,
    "aria-label": ariaLabel
  }, React.createElement(TimesIcon, null)));
};